import { createContext, useCallback, useContext, useMemo, useState } from "react";

const EditorStatusContext = createContext(null);

/** Shared status surfaces: autosave state and the unpublished-changes count. */
export function EditorStatusProvider({ children }) {
  const [saveState, setSaveState] = useState("idle");
  const [pending, setPending] = useState(null);
  const [blocking, setBlocking] = useState(0);
  const [lastSavedAt, setLastSavedAt] = useState(null);

  const markSaved = useCallback((at) => {
    setSaveState("saved");
    setLastSavedAt(at || new Date().toISOString());
  }, []);

  const value = useMemo(
    () => ({
      saveState,
      setSaveState,
      markSaved,
      lastSavedAt,
      pending,
      setPending,
      blocking,
      setBlocking,
    }),
    [saveState, markSaved, lastSavedAt, pending, blocking],
  );

  return <EditorStatusContext.Provider value={value}>{children}</EditorStatusContext.Provider>;
}

export function useEditorStatus() {
  const ctx = useContext(EditorStatusContext);
  if (!ctx) throw new Error("useEditorStatus must be used inside EditorStatusProvider");
  return ctx;
}
